import React from 'react';
import {BrowserRouter, Switch} from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';

import './style/antd.less';
import './style/theme.less';

import {loadUser} from "./actions/auth";
import PrivateRoute from "./components/shared/PrivateRoute";
import DefaultRoute from "./components/shared/DefaultRoute";

import Auth from "./components/auth";
import App from "./components/app";

import * as Sentry from "@sentry/react";

import TagManager from 'react-gtm-module'
import posthog from "posthog-js";
import {PostHogProvider} from "posthog-js/react";

import "driver.js/dist/driver.css";
import EmailUnsubscribe from "./pages/unsubscribe";
import {createRoot} from "react-dom/client";
import PriorityProspectAnalytics from "./analytics";

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID
}

TagManager.initialize(tagManagerArgs);

posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
    capture_pageview: false
});

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
});

class PBNDashboardV4 extends React.Component {
    componentDidMount() {
        store.dispatch(loadUser());
    }

    render() {
        return(
            <PostHogProvider client={posthog}>
                <Provider store={store}>
                    <BrowserRouter>
                        <PriorityProspectAnalytics />
                        <Switch>
                            <DefaultRoute path='/auth/*' component={Auth} />
                            <DefaultRoute path='/unsubscribe' component={EmailUnsubscribe} />
                            <PrivateRoute path='/*' component={App} />
                        </Switch>
                    </BrowserRouter>
                </Provider>
            </PostHogProvider>
        );
    }
}

const root = createRoot(document.getElementById('app'));
root.render(<PBNDashboardV4 />);